/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Checkbox, Divider, FormControlLabel, FormGroup, Grid, TextField } from '@mui/material';
import { FormErrors, IAnomalias, IDetalhesAnomalia } from '../../../services/api/anomaly/AnomalyService';
import SelectAnomalia from './SelectAnomalia';
// import { display } from 'html2canvas/dist/types/css/property-descriptors/display';

const opcoesLocalizacaoAnomalia = [
	{ value: 'Crista', label: 'Crista' },
	{ value: 'Talude de Montante', label: 'Talude de Montante' },
	{ value: 'Talude de Jusante', label: 'Talude de Jusante' },
	{ value: 'Ombreiras e Jusante do Pé', label: 'Ombreiras e Jusante do Pé' },
	{ value: 'Reservatório', label: 'Reservatório' },
	{
		value: 'Sistema de Drenagem Superficial',
		label: 'Sistema de Drenagem Superficial',
	},
	{ value: 'Vertedouro', label: 'Vertedouro' },
	{
		value: 'Sistema de Drenagem Interna',
		label: 'Sistema de Drenagem Interna',
	},
	{
		value: 'Instrumentação',
		label: 'Instrumentação',
	},
	{ value: 'Sinalização', label: 'Sinalização' }
];

const opcoesMagnitude = [
	{ value: 'I', label: 'Insignificante (I)' },
	{ value: 'P', label: 'Pequena (P)' },
	{ value: 'M', label: 'Média (M)' },
	{ value: 'G', label: 'Grande (G)' }
];

const opcoesSituacao = [
	{ value: 'NI', label: 'Não identificado (NI): Condição satisfatória.' },
	{ value: 'PV', label: '1ª ocorrência (PV): Sem ocorrência pretérita registrada.' },
	{ value: 'RE', label: 'Recorrente (RE): Ocorrência já registrada.' },
	{ value: 'PC', label: 'Constante(PC): Ocorrência permaneceu constante.' },
	{ value: 'TR', label: 'Tratada(TR): Ocorrência identificada e registrada previamente, com ação de tratamento realizada.' },
	{ value: 'AU', label: 'Aumentou(AU): Agravamento da ocorrência' },
	{ value: 'DS', label: 'Desapareceu(DS): Anomalia evidênciada em inspeção anterior não apresenta-se aparente no dia da inspeção.' },
	{ value: 'NI_2', label: 'Não inspecionado(NI): Não houve condições para a inspeção visual (descrever motivação no quadro "Observações")' },
	{ value: 'NA', label: 'Não Aplicavél (N.A): Item não se aplica a estrutura avaliada' }
];

export const opcoesNPA = [
	{
		value: 'NORMAL',
		label: 'Normal',
		helperText: 'Quando não há comprometimento da estrutura.'
	},
	{
		value: 'ATENCAO',
		label: 'Atenção',
		helperText: 'Quando não há comprometimento imediato da estrutura, mas haverá caso venha a progredir.'
	},
	{
		value: 'ALERTA',
		label: 'Alerta',
		helperText: 'Quando há comprometimento da estrutura.'
	},
	{
		value: 'EMERGENCIA',
		label: 'Emergência',
		helperText: 'Quando a anomalia representa alta probabilidade de rompimento da barragem.'
	}
];

// const opcoesTipoAnomalia = [
// 	{ value: 'Fissura / Trinca', label: 'Fissura / Trinca' },
// 	{ value: 'Ausência de proteção', label: 'Ausência de proteção' },
// 	{ value: 'Subsidências, depressões ou buracos', label: 'Subsidências, depressões ou buracos' },
// 	{ value: 'Erosões ou ravinamentos superficiais', label: 'Erosões ou ravinamentos superficiais' },
// 	{ value: 'Vegetação arbórea ou arbustiva', label: 'Vegetação arbórea ou arbustiva' },
// 	{ value: 'Acúmulo de água (Inclinação)', label: 'Acúmulo de água (Inclinação)' },
// 	{ value: 'Defeito nos dispositivos de Drenagem', label: 'Defeito nos dispositivos de Drenagem' },
// 	{ value: 'Defeitos na leira', label: 'Defeitos na leira' },
// 	{ value: 'Presença de animais (Formigueiros,tocas,etc.)', label: 'Presença de animais (Formigueiros,tocas,etc.)' }
// ];

// const opcoesAcoes = [
// 	{ value: 'MC - Monitoramento/ Controle', label: 'MC - Monitoramento/ Controle' },
// 	{ value: 'RE - Reparo/ Eliminação', label: 'RE - Reparo/ Eliminação' },
// 	{ value: 'CL -Conservação/ Limpeza', label: 'CL -Conservação/ Limpeza' },
// ];

export const estruturaAnomaliasMap: Record<string, { value: string; label: string }[]> = {
	'Crista': [
		{ value: 'fissura_trinca', label: 'Fissura / Trinca' },
		{ value: 'ausencia_protecao', label: 'Ausência de proteção' },
		{ value: 'subsidencias_buracos', label: 'Subsidências, depresões ou buracos' },
		{ value: 'erosoes_superficiais', label: 'Erosões ou ravinamentos superficiais' },
		{ value: 'vegetacao_arborea', label: 'Vegetação arbórea ou arbustiva' },
		{ value: 'acumulo_agua', label: 'Acúmulo de água (Inclinação)' },
		{ value: 'defeito_drenagem', label: 'Defeito nos dispositivos de Drenagem' },
		{ value: 'defeitos_leira', label: 'Defeitos na leira' },
		{ value: 'presenca_animais', label: 'Presença de animais (Formigueiros,tocas,etc.)' },
	],
	'Talude de Montante': [
		{ value: 'erosoes', label: 'Erosões ou ravinamentos' },
		{ value: 'fissura_trinca', label: 'Fissura / Trinca' },
		{ value: 'ausencia_protecao', label: 'Ausência de proteção' },
		{ value: 'vegetacao_irregular', label: 'Vegetação falha ou crescimento irregular' },
		{ value: 'riprap_danificado', label: 'Rip-Rap danificado ou incompleto' },
		{ value: 'conformacao_inadequada', label: 'Conformação inadequada' },
		{ value: 'presenca_animais', label: 'Presença de animais (Formigueiros,tocas,etc.)' },
		{ value: 'escorregamentos', label: 'Escorregamentos ou Abatimentos' },
	],
	'Talude de Jusante': [
		{ value: 'erosoes', label: 'Erosões ou ravinamentos' },
		{ value: 'fissura_trinca', label: 'Fissura / Trinca' },
		{ value: 'ausencia_protecao', label: 'Ausência de proteção' },
		{ value: 'vegetacao_irregular', label: 'Vegetação falha ou crescimento irregular' },
		{ value: 'riprap_danificado', label: 'Rip-Rap danificado ou incompleto' },
		{ value: 'conformacao_inadequada', label: 'Conformação inadequada' },
		{ value: 'presenca_animais', label: 'Presença de animais (Formigueiros,tocas,etc.)' },
		{ value: 'escorregamentos', label: 'Escorregamentos ou Abatimentos' },
		{ value: 'areas_umidas', label: 'Áreas úmidas, encharcadas/fofas ou surgências' },
	],
	'Ombreiras e Jusante do Pé': [
		{ value: 'erosoes', label: 'Erosões ou ravinamentos' },
		{ value: 'desprendimento_blocos', label: 'Desprendimento de blocos' },
		{ value: 'fraturamento', label: 'Fraturamento' },
		{ value: 'deslizamento', label: 'Deslizamento / rastejo' },
		{ value: 'vegetacao_densa', label: 'Vegetação densa' },
		{ value: 'areas_umidas', label: 'Áreas úmidas, encharcadas/fofas ou surgências' },
		{ value: 'alteracao_solo', label: 'Alteração no solo / rocha' },
		{ value: 'presenca_animais', label: 'Presença de animais (Formigueiros,tocas,etc.)' },
		{ value: 'movimento_massas', label: 'Movimento de massas dos taludes' },
	],
	'Reservatório': [
		{ value: 'praia_inadequada', label: 'Praia inadequada' },
		{ value: 'borda_insuficiente', label: 'Borda livre insuficiente' },
		{ value: 'deslizamento_margens', label: 'Deslizamento/Desmoronamento nas margens' },
		{ value: 'assoreamento', label: 'Assoreamento' },
		{ value: 'presenca_animais', label: 'Presença de animais (Formigueiros,tocas,etc.)' },
		{ value: 'vegetacao_densa', label: 'Vegetação densa' },
		{ value: 'reservatorio_seco', label: 'Reservatório encontrava-se seco:' },
		{ value: 'vertimento_extravasor', label: 'Ocorria vertimento pelo extravasor:' },
	],
	'Sistema de Drenagem Superficial': [
		{ value: 'canaletas_danificadas', label: 'Canaletas danificadas / obstruídas' },
		// eslint-disable-next-line quotes
		{ value: 'escada_danificada', label: "Escada descida d'agua danificada" },
		{ value: 'caixa_assoreada', label: 'Caixa de passagem assoreada' },
		{ value: 'caixa_danificada', label: 'Caixa de passagem danificada' },
		{ value: 'canal_periferico', label: 'Canal periférico danificado/ obstr.' },
		{ value: 'surgencia', label: 'Surgência (especificar estrutura)' },
		{ value: 'erosao', label: 'Erosão (especificar estrutura)' },
		{ value: 'canais_perifericos', label: 'Canais periféricos' },
	],
	'Vertedouro': [
		{ value: 'trincas', label: 'Trincas ou Fissuras' },
		{ value: 'desplacamento', label: 'Desplacamento ou foliações' },
		{ value: 'infiltracoes', label: 'Infiltrações' },
		{ value: 'deslocamentos', label: 'Deslocamentos' },
		{ value: 'turbidez_elevada', label: 'Turbidez elevada' },
		{ value: 'ferragem_exposta', label: 'Ferragem exposta' },
		{ value: 'obstrucao', label: 'Obstrução' },
		{ value: 'necessidade_limpeza', label: 'Necessidade de Limpeza' },
	],
	'Sistema de Drenagem Interna': [
		{ value: 'carreamento_finos', label: 'Carreamento de finos' },
		{ value: 'turbidez_elevada', label: 'Turbidez elevada' },
		{ value: 'bacia_assoreada', label: 'Bacia de dissipação assoreada' },
		{ value: 'dreno_afogado', label: 'Dreno afogado' },
		{ value: 'ferro_bacterias', label: 'Presença de ferro bactérias' },
		{ value: 'fluxo_dreno', label: 'Ocorria fluxo pelo dreno de fundo:' },
	],
	'Instrumentação': [
		{ value: 'acesso_precario', label: 'Acessos Précario' },
		{ value: 'ausencia_instrumentos', label: 'Ausência de instrumentos' },
		{ value: 'falta_protecao', label: 'Falta de proteção dos instrumentos' },
		{ value: 'sem_identificacao', label: 'Instrumento sem identificação' },
		{ value: 'avaria_instrumento', label: 'Avaria no instrumento' },
	],
	'Sinalização': [
		{ value: 'placa_tombada', label: 'Placa tombada' },
		{ value: 'ausencia_placa', label: 'Ausência de placa de identificação' },
		{ value: 'identificacao_ilegivel', label: 'Identificação ilegível' },
		{ value: 'ausencia_placas_rota', label: 'Ausência de placas de rota de fuga' },
	],
};

interface FormAnomaliaProps {
	data: IAnomalias;
	currentDetalhe: IDetalhesAnomalia;
	handleChange: <K extends keyof IAnomalias>(key: K, value: IAnomalias[K]) => void;
	handleChangeDetalhe: <K extends keyof IDetalhesAnomalia>(key: K, value: IDetalhesAnomalia[K]) => void;
	handleChangeFile: (e: React.ChangeEvent<HTMLInputElement>) => void;
	handleImageLegendaChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	imageLegenda: string;
	erros: FormErrors;
}

export default function FormAnomalia({ data, currentDetalhe, handleChange, handleChangeDetalhe, handleChangeFile, handleImageLegendaChange, imageLegenda, erros }: FormAnomaliaProps) {
	const selectedEstrutura = data.estrutura;
	const opcoesAnomalias = estruturaAnomaliasMap[selectedEstrutura] || [];

	const detalhesErros: any = (erros.detalhes || {});

	return (
		<Grid container spacing={2} padding={2}>
			<Grid item xs={6}>
				<SelectAnomalia
					options={opcoesLocalizacaoAnomalia}
					label='Estrutura'
					value={data.estrutura}
					onChange={(e) => handleChange('estrutura', e.target.value)}
					required={true}
					erro={erros.estrutura}
				/>
			</Grid>

			<Grid item xs={6}>
				<TextField
					fullWidth
					label='Data da Inspeção'
					InputLabelProps={{ shrink: true }}
					type='date'
					value={currentDetalhe.data_inspecao}
					onChange={(e) => handleChangeDetalhe('data_inspecao', e.target.value)}
					error={detalhesErros.data_inspecao}
					required
				/>
			</Grid>

			<Grid item xs={6}>
				<SelectAnomalia
					options={opcoesAnomalias}
					label='Anomalia'
					value={currentDetalhe.item}
					disabled={data.estrutura === ''}
					onChange={(e) => handleChangeDetalhe('item', e.target.value)}
					required={true}
					erro={detalhesErros.item}
				/>
			</Grid>

			<Grid item xs={6}>
				<SelectAnomalia
					options={opcoesSituacao}
					label='Situação'
					value={currentDetalhe.situacao}
					onChange={(e) => handleChangeDetalhe('situacao', e.target.value)}
					required={true}
					erro={detalhesErros.situacao}
				/>
			</Grid>

			<Grid item xs={6}>
				<SelectAnomalia
					options={opcoesMagnitude}
					label='Magnitude'
					value={currentDetalhe.magnitude}
					onChange={(e) => handleChangeDetalhe('magnitude', e.target.value)}
					required={true}
					erro={detalhesErros.magnitude}
				/>
			</Grid>

			<Grid item xs={6}>
				<SelectAnomalia
					options={opcoesNPA}
					label='NPA'
					value={currentDetalhe.npa}
					onChange={(e) => handleChangeDetalhe('npa', e.target.value)}
					erro={detalhesErros.npa}
				/>
			</Grid>

			<Grid item xs={12}>
				<TextField
					fullWidth
					label='Observações da Inspeção Atual'
					multiline
					value={currentDetalhe.observacoes_gerais}
					onChange={(e) => handleChangeDetalhe('observacoes_gerais', e.target.value)}
					rows={2}
					error={detalhesErros.observacoes_gerais}
				/>
			</Grid>

			<Grid item xs={6}>
				<TextField
					fullWidth
					type="file"
					onChange={handleChangeFile}
					inputProps={{ accept: '.jpeg,image/jpeg, .gif' }}
					InputLabelProps={{ shrink: true }}
					InputProps={{ notched: false }}
					variant="outlined"
				/>
			</Grid>
			<Grid item xs={6}>
				<TextField
					fullWidth
					label='Legenda da Imagem'
					value={imageLegenda}
					onChange={handleImageLegendaChange}
					variant="outlined"
				/>
			</Grid>

			<Grid item xs={12}><Divider /></Grid>

			{data.estrutura == 'Reservatório' && (
				<Grid item xs={12}>
					<Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingX: 2 }}>
						<FormGroup>
							<FormControlLabel control={<Checkbox checked={currentDetalhe.reservatorio_seco} onChange={(e) => handleChangeDetalhe('reservatorio_seco', e.target.checked)} />} label="Reservatório encontrava-se seco ?" />
							<FormControlLabel control={<Checkbox checked={currentDetalhe.vertimento_extravasor} onChange={(e) => handleChangeDetalhe('vertimento_extravasor', e.target.checked)} />} label="Ocorria vertimento pelo extravasor ?" />
						</FormGroup>
					</Box>
				</Grid>
			)}
			{data.estrutura == 'Sistema de Drenagem Interna' && (
				<Grid item xs={12}>
					<Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingX: 2 }}>
						<FormGroup>
							<FormControlLabel control={<Checkbox checked={currentDetalhe.fluxo_dreno} onChange={(e) => handleChangeDetalhe('fluxo_dreno', e.target.checked)} />} label="Ocorria fluxo pelo dreno de fundo ?" />
						</FormGroup>
					</Box>
				</Grid>
			)}

			{data.file && !(data.file instanceof File) && (
				<Grid item xs={12}>
					<Box
						display="flex"
						justifyContent="center"
					>
						<Box
							border="2px solid black"
							display="flex"
							alignItems="center"
							justifyContent="center"
						>
							<img
								src={`data:image/jpeg;base64,${data.file}`}
								alt="img"
								style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
							/>
						</Box>
					</Box>
				</Grid>
			)}
		</Grid>
	);
}
